import { createSupabaseClient } from '@/integrations/supabase/client';
import { STORAGE_KEYS } from '@/lib/storageKeys';

export type ConsentPreferences = Record<string, boolean>;

export function getOrCreateConsentSessionId(): string {
  const sessionId = localStorage.getItem(STORAGE_KEYS.CONSENT_SESSION_ID);

  if (sessionId) {
    return sessionId;
  }

  const newSessionId = crypto.randomUUID();

  localStorage.setItem(STORAGE_KEYS.CONSENT_SESSION_ID, newSessionId);

  return newSessionId;
}

export async function recordConsentChange(
  userId: string | null,
  preferences: ConsentPreferences,
  getToken?: () => Promise<string | null>
): Promise<void> {
  const payload = {
    user_id: userId ?? null,
    session_id: userId ? null : getOrCreateConsentSessionId(),
    preferences,
  };

  const supabase = createSupabaseClient(getToken ?? undefined);

  const { error } = await supabase.from('cookie_consent_logs').insert(payload);

  if (error) {
    console.error('Failed to record cookie consent change', error);
  }
}

export async function linkAnonymousConsentLogsToUser(
  userId: string,
  getToken: () => Promise<string | null>
): Promise<void> {
  const sessionId = localStorage.getItem(STORAGE_KEYS.CONSENT_SESSION_ID);

  if (!sessionId) {
    return;
  }

  const supabase = createSupabaseClient(getToken);

  const { error, data } = await supabase
    .from('cookie_consent_logs')
    .update({
      user_id: userId,
      session_id: null,
      updated_at: new Date().toISOString(),
    })
    .eq('session_id', sessionId)
    .select('id');

  if (error) {
    console.error('Failed to link anonymous consent logs to user', error);
    return;
  }

  if (data?.length) {
    localStorage.removeItem(STORAGE_KEYS.CONSENT_SESSION_ID);
  }
}
